import { render, staticRenderFns } from "./UserAccountPurchasesTopUpAccount.vue?vue&type=template&id=4f3e845a&"
import script from "./UserAccountPurchasesTopUpAccount.vue?vue&type=script&lang=js&"
export * from "./UserAccountPurchasesTopUpAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountPurchasesTopUpAccount.vue?vue&type=style&index=0&id=4f3e845a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports